import React, { useEffect, useMemo, useState } from "react";
import * as S from "./ListGroupStages.style";
import * as P from "../../../../../../../utils/pipes";
import { useTranslation } from "react-i18next";

function ListGroupStages({
  processGroupStages,
  groupStageId,
  setGroupStageId,
  currentStatus,
  processStagesData,
  setNewCurrentStatus
}) {

  const {t, i18n: { language }} = useTranslation("global");

  const [currentStage, setCurrentStage] = useState();

  useEffect(() => {
    setCurrentStage(processStagesData?.process[0]?.processStages?.find((stage) => stage.id === currentStatus));
  }, [currentStatus,processStagesData])


  const sortedGroupStages = useMemo(() => {
    return processGroupStages?.groupStage
      ?.slice()
      .sort((a, b) =>
          P.dataTranslation(a.comment, language).localeCompare(
          P.dataTranslation(b.comment, language),
          language,
          { numeric: true, sensitivity: "base" }
        )
      );
  }, [processGroupStages, language]);

  return (
    <S.ListGroupStages>
      <div className="status-list">
        {
            sortedGroupStages?.map(
            (groupStage) => {
              
              return (
                <div className="status-item">
                  <button className={
                      `status-item__button 
                      ${
                        groupStageId === groupStage.value
                        ? "status-item__button--selected"
                        : ""
                      }`
                    }
                    onClick={() => {
                      setGroupStageId(groupStage.value);
                      setNewCurrentStatus(null)
                    }}
                  >
                    <div className="status-item__left">
                      <div className="status-item__radio-button">
                        {
                          (groupStage.value === groupStageId) &&
                          <div className="status-item__radio-button-content"></div>
                        }
                      </div>
                      <div className="status-item__text">
                        {P.dataTranslation(groupStage.comment, language)}
                      </div>
                    </div>
                    <div className={
                      `status-item__caption
                      ${
                          groupStage.value === groupStageId
                          ? "status-item__caption--selected"
                          : ""
                      }`
                    }>
                      {
                        groupStage.value === currentStage?.groupStageValue &&
                        t("changeOfStatus.currentGroup")
                      }
                      {
                        groupStage.value === groupStageId && currentStage?.groupStageValue !== groupStageId &&
                        t("changeOfStatus.newGroup")
                      }
                    </div>
                  </button>
                  <div 
                    
                  >
                  </div>
                </div>
              )
            }
          )
        }
        <div className="status-item">
          <button className={
            `status-item__button 
            ${
              groupStageId === 0
              ? "status-item__button--selected"
              : ""
            }`
          }
          onClick={() => {
            setGroupStageId(0);
          }}
        >
          <div className="status-item__left">
            <div className="status-item__radio-button">
              {
                (groupStageId === 0) &&
                <div className="status-item__radio-button-content"></div>
              }
            </div>
            <div className="status-item__text">
              {t("changeOfStatus.withoutGroup")}
            </div>
          </div>
          <div className={
            `status-item__caption
            ${
              groupStageId === 0
                ? "status-item__caption--selected"
                : ""
            }`
          }>
          </div>
        </button>
        </div>
      </div>
    </S.ListGroupStages>
  );
}

export default ListGroupStages;
